<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true" class="cell-template"
          [ngClass]="cellClassGetter ? cellClassGetter(undefined, dataItem) : {}">
        {{getCellSummary(dataItem)}}
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-period-schedule-single-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                                    (valueChange)="controlValueChange($event, dataItem, formGroup)"
                                                    [overrideRequired]="overrideRequired || cellRequired(formGroup, dataItem)"
                                                    [readonly]="readonly || cellDisabled(formGroup, dataItem)"
                                                    [ngClass]="cellClassGetter ? cellClassGetter(formGroup, dataItem) : {}"
                                                    [formControl]="formGroup.get(valueField)"
                                                    [placeholder]="getPlaceholder(dataItem)"
                                                    [objectValue]="formGroup.get(field)">
    </wbo-period-schedule-single-select-edit-control>
</ng-template>
